import * as angular from "angular";
import {IController} from "angular";
import {BillingOrderStatusType} from "../../types/billing-order-status.type";

export class BillingOrderStatusSelectListComponent implements IController {

  status: BillingOrderStatusType;
  ngPlaceholder: any;
  onChange: Function;

  public queryString: string;
  public statuses: BillingOrderStatusType[];

  /* @ngInject */
  constructor() {
    this.statuses = Object.values(BillingOrderStatusType);
  }

  $onInit() {

  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
    .module('bringoz.admin.billing-accounts')
    .component('billingOrderStatusSelectList', {
        bindings: {
          status: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./billing-order-status-select-list.html').default,
        controller: BillingOrderStatusSelectListComponent
    });
